(() => {
  const EMBED_ORIGIN = 'https://my.petroled-signs.com';
  const MESSAGE_TYPE = 'petro-embed-height';

  window.addEventListener('message', (evt) => {
    if (evt.origin !== EMBED_ORIGIN) return;
    if (!evt.data || evt.data.type !== MESSAGE_TYPE) return;

    const reported = Math.round(evt.data.height);
    if (!reported || reported < 100 || reported > 20000) return;

    document.querySelectorAll('iframe').forEach((iframe) => {
      if (iframe.src.indexOf(EMBED_ORIGIN) !== 0) return;
      const current = Math.round(parseFloat(iframe.style.height)) || 0;
      if (Math.abs(current - reported) < 1) return;
      iframe.style.height = `${reported}px`;
    });
  });
})();